import React, { useContext,useState,useCallback } from "react";
import { useDispatch } from "react-redux";

///Styles
import { Container, Content,ButtonFixedContainer, ContainerLoading, Button } from "./styles";

///Components
import { Grid } from "../grid";
import { ButtonPanelPage } from "../../buttonPanelPage";
import { ModalForms } from "../../modalForms";
import { SpaceLoader } from "../../../../loaders/spaceLoader";


///Services
import { MetasContext } from "../goalsContext";
import { orderTable } from "../../../../../Utils/orderTable";

export function GoalsContent() {
    const dispatch = useDispatch()

    const { goals, setGoals,loading, handleNewGoals, loadingButton, page } = useContext(MetasContext);

    const [order,setOrder] = useState(1);

    const handleIsOrder = useCallback((fildName) => {
        setOrder(order => -order);

        let arr = [...goals];

        let newArr = orderTable(arr,fildName,order);

        setGoals(newArr)
    },[goals,order,setGoals]);


    function handleOpenModal() {
        dispatch({ type: 'OPEN_MODALFORMS_CREATE', title: 'Nova Meta' })
    }

    if (loading) {
        return (

            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return (
        <Container>
                <Content>
                    <div className="scroll-grid">
                        <Grid
                            goals={goals}
                            handleIsOrder={handleIsOrder}
                        />
                    </div>


                    {
                        page !== null &&
                        <Button onClick={handleNewGoals} loadingButton={loadingButton} page={page}>
                            {
                                loadingButton ?
                                    '...aguarde'
                                    :
                                    'Ver Mais'
                            }
                        </Button>
                    }
                </Content>

                <ButtonFixedContainer>
                    <ButtonPanelPage
                        label={"Nova Meta"}
                        svg={true}
                        handleClickButton={handleOpenModal}
                    />
                </ButtonFixedContainer>

                <ModalForms />
        </Container>
    )
}